'use strict';

var Model = require('base/Colido.Model');

var TrashModel = Model.extend({
    api: '/trash',
    urlRoot: false, //use api from collection. Pass {collection: ...} as option when initializing model. See commandSendMessageToConversation()
});

module.exports = TrashModel;